import React, { useState } from 'react';
import ReservationModal from '../Home/ReservationModal';

const ReservationsPage: React.FC = () => {
  const [open, setOpen] = useState(false);
  return (
    <section className="bg-cream text-darkBrown min-h-screen pt-32 md:pt-40 lg:pt-44 pb-16 px-6 md:px-12 lg:px-24">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-recia text-center mb-6 text-maroon">Reserve a Table</h1>
        <p className="font-satoshi text-lg text-center mb-4">
          Request a reservation and we’ll follow up to confirm.
        </p>
        <div className="bg-white rounded-lg shadow p-6 md:p-8">
          <p className="mb-4">
            Please note: reservations requested within 24 hours cannot be guaranteed or confirmed via email.
            For assistance, call us at <a className="underline" href="tel:+18055636311">(805) 563-6311</a> at or after the opening hour for that day.
          </p>
          <div className="flex items-center justify-center gap-3 mt-4">
            {/*<button onClick={() => setOpen(true)} className="px-6 py-3 bg-maroon text-cream rounded-full">Reserve a Table</button>*/}
            <a href="tel:+18055636311" className="px-6 py-3 bg-gold text-darkBrown rounded-full">Call Us</a>
          </div>
        </div>
      </div>
      <ReservationModal isOpen={open} onClose={() => setOpen(false)} />
    </section>
  );
};

export default ReservationsPage;